import React from "react";
import Select from "react-select";
import Model from "../../common/Model";

const SubjectForm = ({
  onClose,
  values,
  handleChange,
  handleBlur,
  errors,
  editId,
  touched,
  handleSubmit,
  handleImageChange,
  setFieldValue,
  preview,
  loading,
  subTopicOptions,
}) => {
  const handleSelectAll = (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "all")) {
      if (values.subTopicIds.length === subTopicOptions.length) {
        setFieldValue("subTopicIds", []);
      } else {
        const allOptionValues = subTopicOptions.map((option) => option.value);
        setFieldValue("subTopicIds", allOptionValues);
      }
    } else {
      const selectedValues = selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [];
      setFieldValue("subTopicIds", selectedValues);
    }
  };

  const extendedOptions = [
    { value: "all", label: "Select All" },
    ...subTopicOptions,
  ];
  return (
    <Model
      closeModal={onClose}
      title={`${editId ? "Edit" : "Add"} Subject`}
      isForm={true}
      loading={loading}
      handleSubmit={handleSubmit}
    >
      <div className="custom-scrollbar">
        <div className="space-y-3 mb-8">
          <div>
            <label className="text-sm font-medium text-foreground">
              Sub Topic Name
            </label>
            <Select
              isMulti
              name="subTopicIds"
              options={extendedOptions}
              className="basic-multi-select mt-1"
              classNamePrefix="select"
              value={extendedOptions.filter((option) =>
                values.subTopicIds.includes(option.value)
              )}
              onChange={handleSelectAll}
              onBlur={handleBlur}
              maxMenuHeight={200}
              
            />
            {touched.subTopicIds && errors.subTopicIds && (
              <div className="text-red-500 text-sm">{errors.subTopicIds}</div>
            )}
          </div>

          <div>
            <label className="capitalize text-sm font-medium text-foreground">
              Subject Name
            </label>
            <input
              className="w-full text-base p-2 rounded-xl border border-border focus:outline-none focus:border-primary mt-1"
              type="text"
              placeholder="Enter Subject"
              name="name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {touched.name && errors.name && (
              <div className="text-red-500 text-sm">{errors.name}</div>
            )}
          </div>

          <div>
            <label className="text-sm font-medium text-foreground">Image</label>
            <input
              type="file"
              name="image"
              onChange={handleImageChange}
              className="w-full px-4 py-2 border border-border rounded-xl"
            />
            {touched.image && errors.image && (
              <div className="text-red-500 text-sm">{errors.image}</div>
            )}
            {preview && (
              <div className="mt-4 flex">
                <p className="text-md text-foreground me-3">Preview:</p>
                <img
                  src={preview}
                  alt="ImagePreview"
                  className="w-32 h-32 object-cover border border-border rounded-xl"
                />
              </div>
            )}
          </div>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-2">

          <div className="flex items-center gap-3">
            <span className="text-sm font-medium text-foreground">
              Enable Full Length Subject :
            </span>
            <div className="relative inline-block w-12 h-6">
              <label className="flex cursor-pointer select-none items-center">
                <div className="relative">
                <input
              className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-secondary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-secondary checked:focus:before:ml-[1.0625rem]"
              type="checkbox"
              role="switch"
              id="flexSwitchChecked"
              checked={values.isFullLength}
              onChange={() => {
                setFieldValue("isFullLength", !values.isFullLength); 
              }}
               />
                </div>
              </label>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm font-medium text-foreground">
              Enable Subject Show :
            </span>
            <div className="relative inline-block w-12 h-6">
              <label className="flex cursor-pointer select-none items-center">
                <div className="relative">
                <input
              className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-secondary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-secondary checked:focus:before:ml-[1.0625rem]"
              type="checkbox"
              role="switch"
              id="flexSwitchChecked"
              checked={values.isSubjectShow}
              onChange={() => {
                setFieldValue("isSubjectShow", !values.isSubjectShow); 
              }}
               />
                </div>
              </label>
            </div>
          </div>
          </div>
        </div>
      </div>
    </Model>
  );
};

export default SubjectForm;
